import {TYPE_ICON} from './type-icon.enum';

export class Menu {
  id: any;
  icon: any;
  typeIcon: TYPE_ICON = TYPE_ICON.ICON;
  url: any;
  title: any;
  children: Array<Menu> = [];
}
